// Which of the practice's three buttons can be pressed, and when the row is shown at all.
// Small, but exactly the kind of rule that breaks silently: a button that stays enabled after the
// practice ends, or a hint offered on the sparring partner's turn.

import type { PracticeStatus } from "../state/keys.ts";

export interface PracticeActionsView {
    hidden: boolean;
    hintDisabled: boolean;
    takeBackDisabled: boolean;
    finishDisabled: boolean;
}

export function practiceActionsView({ status, hasLine, isUserTurn, hasOwnMove }: {
    status: PracticeStatus;
    hasLine: boolean;
    isUserTurn: boolean;
    hasOwnMove: boolean;
}): PracticeActionsView {
    const playing = status === "ready" || status === "playing";
    return {
        hidden: status === "finished" || status === "locked" || status === "idle",
        hintDisabled: !playing || !hasLine || !isUserTurn,
        takeBackDisabled: !hasOwnMove || status === "finished",
        finishDisabled: !playing || !hasOwnMove,
    };
}
